<dx-popup [title]="'localAgentsCommands.popupTitle' | translate" [(visible)]="visible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view>
            <dx-form class="wrap" [formData]="agentCommand" [showValidationSummary]="false" labelLocation="top" [colCount]="2">
                <dxi-item itemType="group" [caption]="'_commons.information' | translate">
                    <dxi-item editorType="dxTextBox"
                              [editorOptions]="{ readOnly: true, value: displayCommand(agentCommand) }"
                              [label]="{ text: 'localAgentsCommands.lblCommand' | translate }">
                    </dxi-item>
                    <dxi-item editorType="dxTextBox"
                              [editorOptions]="{ readOnly: true, value: displayStatus(agentCommand) }"
                              [label]="{ text: 'localAgentsCommands.lblStatus' | translate }">
                    </dxi-item>
                    <dxi-item *ngIf="agentCommand.fileTransferName"
                              editorType="dxTextBox"
                              dataField="fileTransferName"
                              [editorOptions]="{ readOnly: true }"
                              [label]="{ text: 'localAgentsCommands.lblTransfer' | translate }">
                    </dxi-item>
                    <dxi-item *ngIf="agentCommand.remotePlatformName"
                              editorType="dxTextBox"
                              dataField="remotePlatformName"
                              [editorOptions]="{ readOnly: true }"
                              [label]="{ text: 'localAgentsCommands.lblRemotePlatform' | translate }">
                    </dxi-item>
                    <dxi-item editorType="dxTextBox"
                              [editorOptions]="{ readOnly: true, value: displayTarget(agentCommand) }"
                              [label]="{ text: 'localAgentsCommands.lblTarget' | translate }">
                    </dxi-item>
                    <dxi-item editorType="dxTextBox"
                              [editorOptions]="{ readOnly: true, value: displayName(agentCommand) }"
                              [label]="{ text: 'localAgentsCommands.lblRequestedBy' | translate }">
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [caption]="'localAgentsCommands.lblResult' | translate">
                    <dxi-item editorType="dxTextArea"
                              dataField="resultData"
                              [editorOptions]="{ readOnly: true, height: '345px' }"
                              [label]="{ text: 'localAgentsCommands.lblResultData' | translate }">
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [caption]="'_commons.duration' | translate" [colSpan]="2" [colCount]="3">
                    <dxi-item dataField="createdOn"
                              editorType="dxDateBox"
                              [editorOptions]="{ displayFormat: 'MMMM d, yyyy HH:mm:ss', readOnly: true, width: '200px' }"
                              [label]="{ text: 'localAgentsCommands.lblCreatedOnUtc' | translate }">
                    </dxi-item>
                    <dxi-item dataField="startedOn"
                              editorType="dxDateBox"
                              [editorOptions]="{ displayFormat: 'MMMM d, yyyy HH:mm:ss', readOnly: true, width: '200px' }"
                              [label]="{ text: 'localAgentsCommands.lblStartedOnUtc' | translate }">
                    </dxi-item>
                    <dxi-item dataField="completedOn"
                              editorType="dxDateBox"
                              [editorOptions]="{ displayFormat: 'MMMM d, yyyy HH:mm:ss', readOnly: true, width: '200px' }"
                              [label]="{ text: 'localAgentsCommands.lblCompletedOnUtc' | translate }">
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [caption]="'_commons.logs' | translate" [colSpan]="2" [colCount]="3">
                    <dxi-item>
                        <div>
                            <div *ngFor="let log of agentCommand.fileTransferLogs; index as i">
                                <a style="color:blue;cursor:pointer;" (click)="openFileTransferLog(log)">{{ 'logs.lblOpenFileTransferLog' | translate }}{{ agentCommand.fileTransferLogs.length > 1 ? ' (' + (i+1).toString() + ')' : '' }}</a><br />
                            </div>
                            <span *ngIf="!agentCommand.fileTransferLogs || agentCommand.fileTransferLogs.length == 0" translate>logs.lblNoFileTransferLog</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div>
                            <div *ngIf="agentCommand.environmentLog">
                                <a style="color:blue;cursor:pointer;" (click)="openEnvironmentLog(agentCommand.environmentLog)" translate>logs.lblOpenEnvironmentLog</a>
                            </div>
                            <span *ngIf="!agentCommand.environmentLog" translate>logs.lblNoEnvironmentLog</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div>
                            <div *ngIf="agentCommand.remotePlatformLog">
                                <a style="color:blue;cursor:pointer;" (click)="openRemotePlatformLog(agentCommand.remotePlatformLog)" translate>logs.lblOpenRemotePlatformLog</a>
                            </div>
                            <span *ngIf="!agentCommand.remotePlatformLog" translate>logs.lblNoRemotePlatformLog</span>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </dx-scroll-view>
        <div class="flex bottom-buttons">
            <dx-button class="close closeButton" [text]="'_commons.close' | translate" (onClick)="this.visible = false"></dx-button>
        </div>
    </div>
</dx-popup>

<!-- Environment Log popup-->
<app-environment-log #environmentLogPopup></app-environment-log>

<!-- File Transfer Log popup-->
<app-file-transfer-log #fileTransferLogPopup></app-file-transfer-log>

<!-- Remote Platform Log popup-->
<app-remote-platform-log #remotePlatformLogPopup></app-remote-platform-log>